import { useSelector } from 'react-redux';

import { CountryDirectionType } from './hooks.type';

import { getInboundCountry, getDispatchCountry } from '../selectors';

export const useCountry = (direction: CountryDirectionType) =>
  useSelector(direction === 'sender' ? getDispatchCountry : getInboundCountry);
